import globConfig from '@/config/config';

//获取/设置 localStorage中的token
export const localToken = {

    //获取token
    get() {
        let that = this;
        // token缓存名 __USER_TOKEN__
        let tokenValue = localStorage.getItem(globConfig.tokenName + this.getDn());
        return this._decodeLocalToken(tokenValue);
    },

    // getWeiXin() {
    //     let that = this;
    //     // 微信 __USER_INFO__
    //     let weixinInfo = {
    //         name: localStorage.getItem(globConfig.weixinInfo_name),
    //         img: localStorage.getItem(globConfig.weixinInfo_img),
    //     }
    //     return weixinInfo;
    // },
    getWeiXinName() {
        return localStorage.getItem(globConfig.weixinInfo_name);
    },
    getWeiXinImg() {
        return localStorage.getItem(globConfig.weixinInfo_img);
    },

    //保存token
    set(value, expire = 0) {

        if (expire === 0) {
            expire = globConfig.tokenExpire; //有效期传入0 使用全局配置
        }

        if (expire <= 10 || expire >= 7776000) { //小于10秒或者大于90天 都变成2小时
            expire = 7200;
        }

        let nowTimestamp = (Date.parse(new Date()) / 1000); //当前时间戳 //后端可以考虑返回服务器的时间
        let expireTime = (nowTimestamp + expire) - 2; //这里转换成过期的具体时间戳

        value += '#expire_time@' + expireTime + '#'; //连接过期时间戳和具体的token值
        //设置一下匿名token
        cache.set(globConfig.anonymousTokenName, value, expire);

        return localStorage.setItem(globConfig.tokenName + this.getDn(), value, expire);

    },
    //   setWeiXin(value, expire = 0) {
    //       localStorage.setItem(globConfig.weixinInfo_name, value.nickname, expire);
    //       localStorage.setItem(globConfig.weixinInfo_img, value.headimgurl, expire);
    //       return true
    // },
    setWeiXinName(value, expire = 0) {
        return localStorage.setItem(globConfig.weixinInfo_name, value, expire);
    },
    setWeiXinImg(value, expire = 0) {
        return localStorage.setItem(globConfig.weixinInfo_img, value, expire);
    },
    getDn() {
        return localStorage.getItem(globConfig.dn);
    },
    setDn(value, expire = 0) {
        return localStorage.setItem(globConfig.dn, value); //, expire
    },
    setTenant(value, expire = 0) {
        return localStorage.setItem(globConfig.tenant + this.getDn(), value); //, expire
    },
    getTenant() {
        return localStorage.getItem(globConfig.tenant + this.getDn());
    },
    getIsSetPwd() {
        return localStorage.getItem(globConfig.setPwd);
    },
    setIsSetPwd(value) {
        return localStorage.setItem(globConfig.setPwd, value);
    },
    //解析token
    _decodeLocalToken(tokenValue) {

        //token值无效
        if (!tokenValue) {
            return '';
        }

        let pattern = /(.+?)#expire_time@(.+?)#/i;
        let r = tokenValue.match(pattern);

        if (null !== r && r.length > 2) {
            let expire_time = r[2] || 0;
            //token 过期
            if (expire_time < (Date.parse(new Date()) / 1000)) {
                return '';
            }
            return r[1];
        }

        return '';
    },

    clearLocal() {
        // return localStorage.clear()
        localStorage.removeItem(globConfig.tokenName + this.getDn());
        localStorage.removeItem(globConfig.weixinInfo_name);
        localStorage.removeItem(globConfig.weixinInfo_img);
        return true
    }
};

//缓存
export const cache = {

    set(name, value, expire = 7200) {
        name += localToken.getDn();
        let _expire = expire || 7200;
        if (null === value) {
            return localStorage.removeItem(name);
        }
        let nowTimestamp = (Date.parse(new Date()) / 1000);
        let expireTime = (nowTimestamp + _expire) - 2; //这里转换成过期的具体时间戳
        value += '#___expire_time___@' + expireTime + '#'; //连接过期时间戳和具体的token值
        return localStorage.setItem(name, value);
    },

    get(name, val = '') {
        name += localToken.getDn();
        let that = this;
        let value = localStorage.getItem(name);
        if (!value) {
            return val;
        }
        value = that._decodeData(value);
        if ('' === value) {
            value = val;
        }
        return value
    },

    //解析数据
    _decodeData(data) {
        if (!data) {
            return '';
        }

        let pattern = /(.+?)#___expire_time___@(.+?)#/i;
        let r = data.match(pattern);

        if (null !== r && r.length > 2) {
            let expire_time = r[2] || 0;
            //缓存过期
            if (expire_time < (Date.parse(new Date()) / 1000)) {
                return '';
            }
            return r[1];
        }
        return '';
    }
};

export const toolFunc = {
    jumpToDn: function(path) {
        let that = this;
        let dn = that.urlQuery('dn');
        if (dn) {
            path += '?dn=' + dn;
        }
        //throw new Error('dsfsd');
        location.href = path;
        return false;
    },
    urlQuery: function(name, url) {
        url = url || location.href;
        let str = url.split('?')[1];
        if (!str) {
            return null;
        }
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = reg.exec(str);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return null;
    },

    urlQueryList: function(url) {
        let str = url || location.href;
        str = str.split('?')[1];
        if (!str) {
            return null;
        }
        let valueList = {};
        //let str = location.href;
        let reg = new RegExp("(^|&)(.+?)=([^&]*)(&|$)", "i");
        let arr = str.split('&');
        for (let i = 0; i < arr.length; i++) {
            let r = reg.exec(arr[i]);
            if (!r) {
                continue;
            }
            //console.log(name, value, 'rrrrrrrrrrr' + i);
            valueList[r[2]] = r[3];
        }
        if (valueList === {}) {
            valueList = null;
        }
        return valueList;
    }
};


// WEBPACK FOOTER //
// ./src/libs/func.js